import React from "react";
import classNames from "classnames";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "@design-system/Popover/Popover";
import { Amount } from "@design-system/Amount/Amount";
import { Separator } from "@design-system/Separator/Separator";
import { TriangleIcon } from "@icons";
import { pluralize } from "@common/helpers/string";
// Same trigger/popover UI and styling as the Transactions command bar total
// (PRO-11992): a bordered trigger button showing the total, expanding on
// hover/click into a breakdown. Invoices have no cash in/out concept, so the
// popover only carries total, count and average.
import styles from "../transactions/TransactionsTotals.module.scss";

interface InvoicesTotalsProps {
    count: number;
    total: number;
    average: number;
}

export const InvoicesTotals: React.FC<InvoicesTotalsProps> = ({
    count,
    total,
    average,
}) => (
    <Popover>
        <PopoverTrigger>
            <div className={styles.triggerButton}>
                <span className="d-block medium text-gray-700">
                    Total:{" "}
                    <Amount
                        amount={total}
                        showNegative
                        className={classNames(
                            total > 0 && styles.positiveAmount,
                        )}
                    />
                </span>
                <TriangleIcon />
            </div>
        </PopoverTrigger>
        <PopoverContent className={styles.popoverContainer}>
            <div className={styles.line}>
                <span>Total</span>
                <Amount
                    amount={total}
                    showNegative
                    className={classNames(total > 0 && styles.positiveAmount)}
                />
            </div>
            <Separator />
            <div className={classNames(styles.line, styles.smallPadding)}>
                <span>{pluralize("Invoice", count)}</span>
                <span>{count}</span>
            </div>
            <div className={styles.line}>
                <span>Average</span>
                <Amount amount={average} />
            </div>
        </PopoverContent>
    </Popover>
);
